import {useState} from "react";
import FlashResultsScoreFractionText from "../../../texts/courses/flash/FlashResultsScoreFractionText";
import FlashResultsScorePercentageText from "../../../texts/courses/flash/FlashResultsScorePercentageText";

export default function ExerciserResultsTotalScore({correctAnswers, total}) {
    // Used in FlashResultsScore to display flash/exerciser either with
    // numeric or percentage value

    // PROPERTIES
    const [showPercentage, setShowPercentage] = useState(false)

    // BUILD
    return (
        <div className="h-full flex items-center pt-24 select-none">
            {showPercentage
                ? <FlashResultsScorePercentageText correctAnswers={correctAnswers}
                                                   total={total}
                                                   toggleShowPercentage={() => setShowPercentage(!showPercentage)} />
                : <FlashResultsScoreFractionText correctAnswers={correctAnswers}
                                                 total={total}
                                                 toggleShowPercentage={() => setShowPercentage(!showPercentage)} />}
        </div>
    );
}